import { CreateSiteRequest, UpdateSiteRequest } from '@/api/sites/types';
import { SingleSite } from '@/core/entities';
import { SiteFormModel } from './types';

const areLevelsUpdated = (
	initialLevels: { id?: string; name: string }[],
	formModelLevels: { id?: string; name: string }[]
) => {
	if (formModelLevels.length !== initialLevels.length) return true;
	if (formModelLevels.includes((level: { id?: string; name: string }) => !level.id)) return true;
	return formModelLevels.some((formLevel) => {
		const originalLevel = initialLevels.find((level) => level.id === formLevel.id);
		return !originalLevel || originalLevel.name !== formLevel.name;
	});
};

export const findUpdatedProps = (
	initialSite: SiteFormModel,
	formModel: SiteFormModel
): string[] => {
	const updatedProps: string[] = [];
	Object.keys(formModel).forEach((key) => {
		if ((key as keyof SiteFormModel) === 'structure') {
			if (areLevelsUpdated(initialSite.structure, formModel.structure)) updatedProps.push('levels');
		} else if (formModel[key as keyof SiteFormModel] !== initialSite[key as keyof SiteFormModel]) {
			updatedProps.push(key);
		}
	});
	return updatedProps;
};

export const makeCreateSiteRequestFromFormModel = (formModel: SiteFormModel): CreateSiteRequest => {
	const { siteAdminName, siteAdminTitle, siteAdminEmail, structure } = formModel;
	return {
		...formModel,
		siteAdminName: siteAdminName.length ? siteAdminName : null,
		siteAdminTitle: siteAdminTitle.length ? siteAdminTitle : null,
		siteAdminEmail: siteAdminEmail.length ? siteAdminEmail : null,
		structure: structure.map((level) => level.name),
	};
};

export const makeUpdateSiteRequestFromFormModel = (formModel: SiteFormModel): UpdateSiteRequest => {
	const { structure: levels, siteAdminName, siteAdminTitle, siteAdminEmail, ...rest } = formModel;
	return {
		...rest,
		siteAdminName: siteAdminName.length ? siteAdminName : null,
		siteAdminTitle: siteAdminTitle.length ? siteAdminTitle : null,
		siteAdminEmail: siteAdminEmail.length ? siteAdminEmail : null,
		levels,
	};
};

export const makeFormModelFromSite = (site: SingleSite): SiteFormModel => {
	const { siteAdminName, siteAdminTitle, siteAdminEmail, levels } = site;
	return {
		...site,
		siteAdminName: siteAdminName ?? '',
		siteAdminTitle: siteAdminTitle ?? '',
		siteAdminEmail: siteAdminEmail ?? '',
		structure: levels?.map((level) => ({ id: level.id, name: level.name })),
	};
};

export const getDefaultSiteFormModel = (): SiteFormModel => ({
	name: '',
	address: '',
	city: '',
	state: '',
	zip: '',
	timeZone: '',
	siteAdminName: '',
	siteAdminTitle: '',
	siteAdminEmail: '',
	structure: [{ name: '' }],
});
